export default __webpack_public_path__ + "static/media/requirements_grey.c37dae41.svg";